export default __webpack_public_path__ + "295e9385b61b2c3906fc12db48d94caa.png";